"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = _interopRequireDefault(require("underscore"));

var _cornerExpand = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/corner-expand"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./TextArea.less");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextArea = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TextArea, _Component);

  var _super = _createSuper(TextArea);

  function TextArea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TextArea);
    _this = _super.call(this, props);
    _this.state = {
      value: _this.props.value || _this.props.children || '',
      style: {}
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleResizeStop = _this.handleResizeStop.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TextArea, [{
    key: "handleResizeInit",
    value: function handleResizeInit(e) {
      if (e.button === 0) {
        // only do it on left button
        window.addEventListener('mousemove', this.handleResize, false);
        window.addEventListener('mouseup', this.handleResizeStop, false);
        this.setState({
          dragging: true,
          dragStart: {
            x: e.clientX,
            y: e.clientY,
            width: this.wrapper.clientWidth,
            height: this.wrapper.clientHeight
          }
        });
      }
    }
  }, {
    key: "handleResizeStop",
    value: function handleResizeStop() {
      window.removeEventListener('mousemove', this.handleResize, false);
      window.removeEventListener('mouseup', this.handleResizeStop, false);
    }
  }, {
    key: "handleResize",
    value: function handleResize(e) {
      e.preventDefault();
      var _this$props = this.props,
          resizeX = _this$props.resizeX,
          resizeY = _this$props.resizeY;
      var state = {
        style: {}
      }; // take the original size and add the number of pixels the mouse has moved since drag start

      if (resizeX) {
        state.style.width = "".concat(this.state.dragStart.width + (e.clientX - this.state.dragStart.x), "px");
      }

      if (resizeY) {
        state.style.height = "".concat(this.state.dragStart.height + (e.clientY - this.state.dragStart.y), "px");
      }

      this.setState(state);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      this.setState({
        focused: true
      });
      this.props.onFocus && this.props.onFocus(e);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      this.setState({
        focused: false
      });
      this.props.onBlur && this.props.onBlur(e);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var value = e.target.value;
      this.setState({
        value: value
      });

      if (typeof this.props.onHandleChange === 'function') {
        //pass in the value and the length
        this.props.onHandleChange(value, value.trim().length);
      }

      this.props.onChange(e);
    }
  }, {
    key: "isResizable",
    value: function isResizable() {
      return this.props.resizable && (this.props.resizeX || this.props.resizeY);
    }
  }, {
    key: "renderCounter",
    value: function renderCounter() {
      var counterFormat = '';

      if (this.props.showCounter !== false || this.isResizable()) {
        if (this.props.showCounter !== false) {
          if (this.props.maxLength) {
            counterFormat = /*#__PURE__*/_react.default.createElement("span", null, " Characters Used: ", this.state.value.trim().length, " of ", this.props.maxLength, ".");
          } else {
            counterFormat = /*#__PURE__*/_react.default.createElement("span", null, this.state.value.trim().length);
          }
        }

        return /*#__PURE__*/_react.default.createElement("div", {
          className: "counter"
        }, counterFormat, this.renderResizeHandle());
      }
    }
  }, {
    key: "renderResizeHandle",
    value: function renderResizeHandle() {
      var _this2 = this;

      if (this.isResizable()) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "resize-handle",
          onMouseDown: function onMouseDown(e) {
            _this2.handleResizeInit(e);
          }
        }, /*#__PURE__*/_react.default.createElement(_cornerExpand.default, null));
      }
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var _this$props2 = this.props,
          maxLength = _this$props2.maxLength,
          valid = _this$props2.valid;

      if ([true, false].includes(valid)) {
        return valid ? 'valid' : 'error';
      }

      var valueLength = this.state.value.trim().length;

      if (valueLength == 0) {
        return undefined;
      } else if (!maxLength || valueLength <= maxLength) {
        return 'valid';
      } else {
        return 'error';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var value = this.state.value;
      var textAreaOnly = this.props.showCounter === false && this.props.resizable === false;
      var className = (0, _classnames.default)('primitive-text-area', this.props.className, this.isValid(), {
        'is-focused': this.state.focused
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className,
        style: _objectSpread(_objectSpread({}, this.props.style), this.state.style),
        ref: function ref(r) {
          return _this3.wrapper = r;
        }
      }, /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({}, _underscore.default.omit(this.props, 'resizable', 'showCounter', 'onHandleChange', 'resizeX', 'resizeY', 'minX', 'minY', 'maxX', 'maxY', 'style', 'maxLength'), {
        className: textAreaOnly ? 'textarea-only' : '',
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        value: value
      })), this.renderCounter());
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        resizable: _propTypes.default.bool,
        resizeX: _propTypes.default.bool,
        resizeY: _propTypes.default.bool,
        minX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
        minY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
        maxX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
        maxY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
        showCounter: _propTypes.default.bool,
        valid: _propTypes.default.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        resizable: true,
        resizeX: true,
        resizeY: true,
        minX: '',
        minY: '',
        maxX: '',
        maxY: '',
        showCounter: true,
        onChange: _underscore.default.noop,
        onHandleChange: _underscore.default.noop
      };
    }
  }]);
  return TextArea;
}(_react.Component);

exports.default = TextArea;